<div class="reports-page">
    <div class="conatiner-page-header">Reports</div>
    <!-- SELECT REPORTS -->
    <mat-card>
        <div class="reports-page-content">
            <div class="form-group">
                <mat-form-field>
                    <mat-select
                        disableOptionCentering
                        placeholder="Select Reports"
                        [(value)]="selectedReportType"
                        (selectionChange)="onReportChange($event)"
                    >
                        <ng-template
                            ngFor
                            let-report
                            [ngForOf]="reportsList"
                        >
                            <mat-option
                                *ngIf="!report?.disabled"
                                [(value)]="report.type"
                            >
                                {{
                report.name
              }}
                            </mat-option>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- -START & END DATE -->
            <div
                class="align-h"
                *ngIf="selectedReportType !== 'UNIQUE_LOGIN_COUNT_REPORT' && selectedReportType !== 'USER_RIGHTS'"
            >
                <div class="form-group stretch margin-right-40">
                    <mat-form-field>
                        <input
                            placeholder="Start Date"
                            matInput
                            [matDatepicker]="picker1"
                            [(ngModel)]="startDate"
                            name="fromDate"
                            [max]="today"
                        >
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker1"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #picker1
                            color="primary"
                        ></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-group stretch">
                    <mat-form-field>
                        <input
                            placeholder="End Date"
                            matInput
                            [matDatepicker]="picker2"
                            [(ngModel)]="endDate"
                            name="fromDate"
                            [max]="today"
                            [min]="startDate"
                        >
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker2"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #picker2
                            color="primary"
                        ></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <!-- START YEAR, END YEAR, & SOURCE -->
            <div
                class="align-h"
                *ngIf="selectedReportType === 'UNIQUE_LOGIN_COUNT_REPORT'"
            >
                <div class="form-group stretch margin-right-40">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Start Year"
                            [(ngModel)]="selectedStartYear"
                            name="startyear"
                            #startyear="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let year of yearList"
                                [value]="year.label"
                            >
                                {{ year.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-group stretch">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="End Year"
                            [(ngModel)]="selectedEndYear"
                            name="endyear"
                            #endyear="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let year of yearList"
                                [value]="year.label"
                            >
                                {{ year.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-group stretch">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Source"
                            [(ngModel)]="selectedSource"
                            name="source"
                            #source="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let item of sourceList"
                                [value]="item.value"
                            >
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <!-- DOWNLOAD -->
            <div class="report-align-button-center">
                <button
                    mat-raised-button
                    color="primary"
                    class="mat-button-large"
                    type="submit"
                    align="center"
                    (click)="downloadReports()"
                >
                    Download
                </button>
            </div>
        </div>
    </mat-card>
</div>
